import React from 'react';
import { Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const STAT_DEFS = [
  {
    key: 'all',
    icon: <GroupsIcon />,
    label: 'Live Activities',
    accent: 'var(--ts-primary)',
    match: () => true,
  },
  {
    key: 'good',
    icon: <CheckCircleOutlineIcon />,
    label: 'On Track',
    accent: 'var(--ts-status-success)',
    match: (r) => r.badgeStatus === 'good',
  },
  {
    key: 'warning',
    icon: <WarningAmberIcon />,
    label: 'Running Late',
    accent: 'var(--ts-status-warning)',
    match: (r) => r.badgeStatus === 'warning',
  },
  {
    key: 'error',
    icon: <ErrorOutlineIcon />,
    label: 'Overdue',
    accent: 'var(--ts-status-error)',
    match: (r) => r.badgeStatus === 'error',
  },
];

const StatCard = ({ icon, label, value, accent, isActive, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex items-center gap-3 rounded-2xl border p-4 text-left transition-colors cursor-pointer hover:shadow-md ${
      isActive
        ? 'border-transparent shadow-md'
        : 'border-[var(--ts-border)] bg-[var(--ts-surface)] shadow-sm'
    }`}
    style={
      isActive
        ? { backgroundColor: `${accent}14`, borderColor: accent }
        : undefined
    }
  >
    <div
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
      style={{ backgroundColor: `${accent}1f`, color: accent }}
    >
      {icon}
    </div>
    <div>
      <Typography variant="h4" className="!font-bold !leading-none">
        {value}
      </Typography>
      <Typography variant="body2" className="text-[var(--Grey-70)]">
        {label}
      </Typography>
    </div>
  </button>
);

// KPI counts that double as the status filter for the activity grid below.
const StatusFilterCards = ({ rows, activeFilter, onFilterChange }) => (
  <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
    {STAT_DEFS.map((def) => (
      <StatCard
        key={def.key}
        icon={def.icon}
        label={def.label}
        value={rows.filter(def.match).length}
        accent={def.accent}
        isActive={activeFilter === def.key}
        onClick={() => onFilterChange(def.key)}
      />
    ))}
  </div>
);

export default StatusFilterCards;
